import styled from 'styled-components';
import Main from './components/Main';
import { titleHTML } from '../../helpers/title.helper';

const Academic = () => {
    titleHTML('Información académica');

    // RETURN
    return (
        <AcademicContainer>
            <ContentWrapper>
                <Main handleSetStateDocumentation={() => {}} />
            </ContentWrapper>
        </AcademicContainer>
    );
};

export default Academic;

const AcademicContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 2rem;
`;

const ContentWrapper = styled.div`
    width: 100%;
`;
